import axios from 'axios';
import { retrieveToken } from 'services/auth.service';

const wrappedAxios = axios;

wrappedAxios.interceptors.request.use((config) => {
  const token = retrieveToken();
  if (token != null) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default wrappedAxios;
